import React from 'react';

import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import {VIEW_TYPE} from '../enums/ViewType';
import {IconGridButton, IconListButton} from "./buttons/IconButtons";
/**
 * @Description Component with list or card option.
 * @param useState view: value of state (optional).
 * @param useState setView: value update state (optional).
 * @param boolean disabled: Enable/disable button (optional)
 * @param string className: Additional style for the list-grid component (optional)
 *
 * @param {Object} props - React props
 * @param {string} props.view - Current selected view type (`LIST` or `GRID`)
 * @param {Function} props.setView - Function to update the selected view
 * @param {boolean} [props.disabled=false] - Whether the toggle buttons are disabled
 * @param {string} [props.className='ml-8px'] - Optional custom CSS class for container styling
 * @param {React.ElementType} [props.iconLeft=IconListButton] - Icon component used for list view
 * @param {React.ElementType} [props.iconRight=IconGridButton] - Icon component used for grid view
 *
 * @returns {JSX.Element}
 */
const DisplayView = ({
                         view,
                         setView,
                         disabled=false,
                         className='ml-8px',
                         iconLeft = IconListButton,
                         iconRight = IconGridButton,
}) => {
    const lCode = Cookies.get('i18next') || 'en';
    const { t } = useTranslation();

    const LeftIcon = iconLeft;
    const RightIcon = iconRight;


    return (
        <div className={`grid_list ${className}`}>
            <Tooltip title={t('list_view').toUpperCase()} placement='bottom' disableInteractive>
                <div id={'btn_dv_list_view'}
                    className={`custom-list-grid ${lCode === 'ar' ? 'listA' : 'list'}  ${disabled ? 'disabled' : ''} ${view === VIEW_TYPE.LIST.name ? 'active' : ''}`}
                    onClick={() => {
                        setView(VIEW_TYPE.LIST.name);
                    }}
                >
                    {iconLeft && <LeftIcon className={`mr-1 btn-icon-svg-20px ${view === VIEW_TYPE.LIST.name ? 'icon-color-shades-950' : 'icon-color-shades-500'}`}/>}
                </div>
            </Tooltip>
            <Tooltip title={t('detail_view').toUpperCase()} placement='bottom' disableInteractive>
                <div id={'btn_dv_grid_view'}
                    className={`custom-list-grid ${lCode === 'ar' ? 'gridA' : 'grid'} ${disabled ? 'disabled' : ''} ${view === VIEW_TYPE.GRID.name ? 'active' : ''}`}
                    onClick={() => {
                        setView(VIEW_TYPE.GRID.name);
                    }}
                >
                    {iconRight && <RightIcon className={`mr-1 btn-icon-svg-20px ${view === VIEW_TYPE.GRID.name ? 'icon-color-shades-950' : 'icon-color-shades-500'} `}/>}
                </div>
            </Tooltip>
        </div>
    );
};

export default DisplayView;
